import axios from "axios";
import i18n from "@/i18n";
const config = require('@/config')
const modifiers = {
    state: () => ({
        modifiers: {},
        modifiersCat: [],
        modifiersSort: 'default',
        options: {},
        optionsCat: [],
        loading: {
            add: false,
            get: false,
            remove: false,
            option: false,
        },
    }),
    getters: {
        MODIFIERS(state) {return state.modifiers},
        MODIFIERS_CAT(state) {return state.modifiersCat},
        MODIFIERS_LOADING(state) {return state.loading},
        MODIFIERS_SORT(state) {return state.modifiersSort},
        OPTIONS(state) {return state.options},
        OPTIONS_CAT(state) {return state.optionsCat},
    },
    mutations: {
        setModifiers(state, payload) {
            state.modifiers = payload
        },
        setModifiersCat(state, payload) {
            state.modifiersCat = payload
        },
        setLoading(state, payload) {
            state.loading[payload[0]] = payload[1]
        },
        setModifiersSort(state, payload) {
          state.modifiersSort = payload;
        },
        setOptions(state, payload) {
            state.options = payload
        },
        setOptionsCat(state, payload) {
            state.optionsCat = payload
        },
        getImageForOptions(state, payload) {
            Object.values(payload.options).forEach( (item) => {
                let url = `${config.servImgUrl}${payload.companyId}/${item.restaurant_id}/${item.id}/images/thumbnail.jpg`
                state.options[item.id].src = url
            })
        },
        clearAllModifiersAndOptions(state) {
            state.modifiers = {}
            state.modifiersCat = []
            state.modifiersSort = 'default'
            state.options = {}
            state.optionsCat = []
        }
    },
    actions: {
        // TODO: Modifiers
        async addModifier({state, commit, dispatch, rootState}, payload) {
            await dispatch('tryAutoSignIn', null, { root: true })
            this.commit('setLoading', ['add', true ])
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            return axios.post(`${config.servUrl}admin/menu-item-modifiers/` + payload.restId, payload.newMf, axiosHeader)
                .then(response => {
                    this.commit('setLoading', ['add', false ])
                    this.dispatch('getModifiers', payload.restId)
                    dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.modifierAdded')})
                    return true
                })
                .catch(error => {
                    this.commit('setLoading', ['add', false ])
                    dispatch('addNewNotice', {text: error, error: true})
                    console.log(error)
                    return false
                })

        },
        async changeModifier({state, commit, dispatch, rootState}, payload) {
            await dispatch('tryAutoSignIn', null, { root: true })
            this.commit('setLoading', ['add', true ])
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            return axios.put(`${config.servUrl}admin/menu-item-modifiers/${payload.restId}/${payload.newMf.id}`, payload.newMf, axiosHeader)
                .then(response => {
                    this.commit('setLoading', ['add', false ])
                    this.dispatch('getModifiers', payload.restId)
                    dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.modifierChanged')})
                    return true
                })
                .catch(error => {
                    this.commit('setLoading', ['add', false ])
                    dispatch('addNewNotice', {text: error, error: true})
                    console.log(error)
                    return false
                })

        },
        async removeModifier({state, commit, dispatch, rootState}, payload) {
            await dispatch('tryAutoSignIn', null, { root: true })
            this.commit('setLoading', ['remove', true ])
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            axios.delete(`${config.servUrl}admin/menu-item-modifiers/${payload.restaurant_id}/${payload.id}`, axiosHeader)
                .then(response => {
                    this.commit('setLoading', ['remove', false ])
                    this.dispatch('getModifiers', payload.restaurant_id)
                    dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.modifierRemoved')})
                })
                .catch(error => {
                    this.commit('setLoading', ['remove', false ])
                    dispatch('addNewNotice', {text: error, error: true})
                    console.log(error);
                })

        },
        async getModifiers({state, commit, dispatch, rootState}, restId) {
            await dispatch('tryAutoSignIn', null, { root: true })
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            await axios.get(`${config.servUrl}admin/menu-item-modifiers/` + restId, axiosHeader)
                .then(response => {
                    this.commit('setModifiers', response.data)
                    this.dispatch('getModifiersCat', response.data)
                })
                .catch(error => {
                    console.log(error);
                    dispatch('addNewNotice', {text: error, error: true})
                })
        },
        getModifiersCat({commit}, payload) {
            let set = new Set();
            for (let key in payload) {
                set.add(payload[key].category);
            }
            this.commit('setModifiersCat', set);
        },

        // TODO: Option in Modifiers
        async changeOptionInModifier({state, commit, dispatch, rootState}, payload) {
            await dispatch('tryAutoSignIn', null, { root: true })
            this.commit('setLoading', ['option', true ])
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            return axios.put(`${config.servUrl}admin/menu-item-modifiers/${payload.restId}/${payload.id}`, payload.options, axiosHeader)
                .then(response => {
                    this.dispatch('getModifiers', payload.restId)
                    this.commit('setLoading', ['option', false])
                    dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.modifierOptionsUpdated')})
                    return true
                })
                .catch(error => {
                    this.commit('setLoading', ['option', false])
                    dispatch('addNewNotice', {text: error, error: true})
                    console.log(error);
                    return false
                })
        },

        // TODO: Option
        async addOption({state, commit, dispatch, rootState}, payload) {
            await dispatch('tryAutoSignIn', null, { root: true })
            this.commit('setLoading', ['add', true ])
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            return axios.post(`${config.servUrl}admin/menu-item-options/` + payload.restId, payload.newOption, axiosHeader)
                .then(response => {
                    if (payload.img) {
                        dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.modifierOptionAdded')})
                        return this.dispatch('addImageForOption', {
                            restId: payload.restId,
                            id: response.data.id,
                            img: payload.img
                        })
                    } else {
                        this.dispatch('getOptions', payload.restId)
                        this.commit('setLoading', ['add', false ])
                        dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.modifierOptionAdded')})
                        return true
                    }
                })
                .catch(error => {
                    this.commit('setLoading', ['add', false ])
                    dispatch('addNewNotice', {text: error, error: true})
                    console.log(error);
                    return false
                })
        },
        async changeOption({state, commit, dispatch, rootState}, payload) {
            await dispatch('tryAutoSignIn', null, { root: true })
            this.commit('setLoading', ['add', true ])
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            return axios.put(`${config.servUrl}admin/menu-item-options/${payload.restId}/${payload.newOption.id}`, payload.newOption, axiosHeader)
                .then(response => {
                    if (payload.img) {
                        dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.modifierOptionUpdated')})
                        return this.dispatch('addImageForOption', {
                            restId: payload.restId,
                            id: response.data.id,
                            img: payload.img
                        })
                    } else {
                        this.dispatch('getOptions', payload.restId)
                        this.commit('setLoading', ['add', false])
                        dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.modifierOptionUpdated')})
                        return true
                    }
                })
                .catch(error => {
                    this.commit('setLoading', ['add', false ])
                    dispatch('addNewNotice', {text: error, error: true})
                    console.log(error);
                    return false
                })

        },
        async getOptions({state, commit, dispatch, rootState}, restId) {
            await dispatch('tryAutoSignIn', null, { root: true })
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            await axios.get(`${config.servUrl}admin/menu-item-options/` + restId, axiosHeader)
                .then(response => {
                    this.commit('setOptions', response.data)
                    this.dispatch('getOptionsCat', response.data)
                    this.commit('getImageForOptions', {options: Object.values(response.data), companyId: rootState.company.id})
                })
                .catch(error => {
                    console.log(error);
                    dispatch('addNewNotice', {text: error, error: true})
                })
        },
        async addImageForOption({state, commit, dispatch, rootState}, payload) {
            await dispatch('tryAutoSignIn', null, { root: true })
            let idToken = rootState.tokens.idToken
            let restId = payload.restId
            let axiosHeader = {headers: {"Authorization": idToken, "Content-Type": 'multipart/form-data'}}
            const formData = new FormData();
            formData.append('fileContent', payload.img);
            formData.append('entityType', 'menu_item_option');
            formData.append('restaurantId', restId);
            formData.append('menuItemOptionId', payload.id);
            return axios.post(`${config.servUrl}admin/image-upload`, formData, axiosHeader)
                .then(response => {
                    this.dispatch('getOptions', payload.restId)
                    this.commit('setLoading', ['add', false ])
                    dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.imageUploaded')})
                    return true
                })
                .catch(error => {
                    this.commit('setLoading', ['add', false ])
                    dispatch('addNewNotice', {text: error, error: true})
                    console.log(error);
                    return false
                })
        },
        getOptionsCat({commit}, payload) {
            let set = new Set();
            for (let key in payload) {
                set.add(payload[key].category);
            }
            this.commit('setOptionsCat', set);
        },
        async deleteOption({state, commit, dispatch, rootState}, payload) {
            await dispatch('tryAutoSignIn', null, { root: true })
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            axios.delete(`${config.servUrl}admin/menu-item-options/${payload.restaurant_id}/${payload.id}`, axiosHeader)
                .then(response => {
                    this.dispatch('getOptions', payload.restaurant_id)
                    dispatch('addNewNotice', {text: i18n.global.t('storeAlerts.modifierOptionRemoved')})
                })
                .catch(error => {
                    dispatch('addNewNotice', {text: error, error: true})
                    console.log(error);
                })
        }
    },

}

export {modifiers}
